import script from "./AttachmentSendingModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./AttachmentSendingModal.vue?vue&type=script&lang=ts&setup=true"

import "./AttachmentSendingModal.vue?vue&type=style&index=0&id=2e79bf62&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2e79bf62"]])

export default __exports__